module.exports = __webpack_public_path__ + "689e877262c8de9c7e9a17aa1705bc20.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-320.webp
// module id = 427
// module chunks = 0